import React from "react";
import PropTypes from "prop-types";
// Material imports
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
// Limitless imports
import { getLastAmbassadorDialogue } from "@limitless/common/utils";
import RatingSystem from "../csat-footer/RatingSystem";
import { withi18n } from "../../hocs/i18n";
import { ratingStyles } from "./CSATScreen";
import CustomerButton from "../../customer-button/CustomerButton";
const EXPERT_FEEDBACK = [{
  label: "Valuing my time",
  value: "value"
}, {
  label: "Communication",
  value: "communication"
}, {
  label: "Listening",
  value: "listening"
}, {
  label: "Making things easy",
  value: "easy"
}, {
  label: "Wanting to solve my issue",
  value: "issue"
}, {
  label: "Knowledge",
  value: "knowledge"
}, {
  label: "Something Else?",
  value: "somthingelse"
}];
const ExpertFeedbackScreen = ({
  message,
  t,
  classes,
  onSubmitExpertScore,
  onSubmitExpertFeedback,
  containerClass
}) => {
  var _message$custClientRe, _message$custClientRe2, _message$custClientRe3;
  const [score, setScore] = React.useState(-1);
  const [showSomthingElseBox, setShowSomthingElseBox] = React.useState(false);
  const [showSomthingElseText, setShowSomthingElseTest] = React.useState();
  const [expertFeedbackList, setExpertFeedbackList] = React.useState(EXPERT_FEEDBACK);
  const [hasShuffled, setHasShuffled] = React.useState(false);
  const [feedbackList, setFeedbackList] = React.useState((_message$custClientRe = (_message$custClientRe2 = message.custClientReview) === null || _message$custClientRe2 === void 0 ? void 0 : (_message$custClientRe3 = _message$custClientRe2.expertFeedback) === null || _message$custClientRe3 === void 0 ? void 0 : _message$custClientRe3.split(",")) !== null && _message$custClientRe !== void 0 ? _message$custClientRe : []);
  const {
    hasSingleExpert,
    lastDialogue: {
      author = ""
    },
    thumbnail
  } = getLastAmbassadorDialogue(message);
  const handleExpertRate = score => {
    setScore(score);
    onSubmitExpertScore(score);
  };
  function shuffle(arrayofexpertfeedback) {
    let feedbackcount = arrayofexpertfeedback.length - 1;
    let temp;
    let index;
    while (feedbackcount > 0) {
      index = Math.floor(Math.random() * feedbackcount);
      feedbackcount--;
      temp = arrayofexpertfeedback[feedbackcount];
      arrayofexpertfeedback[feedbackcount] = arrayofexpertfeedback[index];
      arrayofexpertfeedback[index] = temp;
    }
    return arrayofexpertfeedback;
  }
  React.useEffect(() => {
    if (!hasShuffled) {
      const suffleArray = shuffle(EXPERT_FEEDBACK);
      setExpertFeedbackList(suffleArray);
      setHasShuffled(true);
    }
  }, [score, hasShuffled]);
  const handleExpertFeedback = value => {
    if (value === "somthingelse") {
      setShowSomthingElseBox(!showSomthingElseBox);
    } else {
      if (feedbackList.includes(value)) {
        setFeedbackList(feedbackList.filter(item => item !== value));
      } else {
        setFeedbackList([value, ...feedbackList]);
      }
    }
  };
  const handleNext = () => {
    if ((showSomthingElseText === null || showSomthingElseText === void 0 ? void 0 : showSomthingElseText.length) > 0) {
      feedbackList.push(showSomthingElseText);
    }
    onSubmitExpertFeedback(feedbackList.toString());
  };
  const handleTextChange = text => {
    setShowSomthingElseTest(text);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${containerClass} ${!hasSingleExpert || !thumbnail ? classes.center : ""}`
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    classes: {
      subtitle2: classes.heading
    },
    component: "div"
  }, t("We'd also like to hear about {0}, the expert you just worked with.", author), t("How did {0} do?", author)), /*#__PURE__*/React.createElement("div", {
    className: classes.ratingWrapper
  }, /*#__PURE__*/React.createElement(RatingSystem, {
    isexpertScore: true,
    onClick: handleExpertRate,
    message: message,
    disabled: false
  })), /*#__PURE__*/React.createElement("div", null, score > 0 || showSomthingElseBox || feedbackList.length > 0 ? /*#__PURE__*/React.createElement("div", null, score > 3 ? /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    classes: {
      subtitle2: classes.subheading
    },
    component: "div"
  }, t("That's great. What did {0} do well?", author)) : /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    classes: {
      subtitle2: classes.subheading
    },
    component: "div"
  }, t("That's disappointing. What can {0} improve?", author)), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    style: {
      flexDirection: "column",
      minWidth: 240,
      alignItems: "center",
      marginTop: 16,
      marginBottom: showSomthingElseBox ? 0 : 16
    }
  }, expertFeedbackList.map((item, index) => {
    const selected = feedbackList.some(feedbackitem => feedbackitem === item.value) || showSomthingElseBox && item.value === "somthingelse";
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      key: index,
      value: item.value,
      className: `${classes.expertFeedBackList}`
    }, /*#__PURE__*/React.createElement("div", {
      key: item.value,
      onClick: () => {
        handleExpertFeedback(item.value);
      },
      className: `${classes.listItem} ${selected ? classes.active : ""}`
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      id: index
    }, t(item.label))));
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    style: {
      alignItems: "center",
      marginTop: 12,
      marginBottom: 12
    }
  }, showSomthingElseBox && /*#__PURE__*/React.createElement(TextField, {
    classes: {
      root: classes.textField
    },
    id: "somthingelsebox",
    variant: "outlined",
    multiline: true,
    rows: 4,
    InputProps: {
      classes: {
        notchedOutline: classes.notchedOutline,
        focused: classes.focused
      }
    },
    onChange: event => handleTextChange(event.target.value)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.nextButtonContainer
  }, /*#__PURE__*/React.createElement(CustomerButton, {
    onClick: handleNext,
    component: "div",
    id: "nextButtonofexpertfeedback",
    style: {
      width: 100
    }
  }, "Next"))) : /*#__PURE__*/React.createElement(React.Fragment, null)));
};
const styles = theme => ({
  ...ratingStyles(theme),
  heading: {
    textAlign: "center"
  },
  subheading: {
    textAlign: "center",
    marginTop: 24
  },
  active: {
    backgroundColor: "#CCDCFF!important",
    border: "none!important",
    outline: "none"
  },
  listItem: {
    minWidth: 240,
    height: 40,
    paddingTop: 0,
    paddingBottom: 0,
    borderRadius: 4,
    border: "1px solid",
    borderColor: "#A3A8A8",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)"
    }
  },
  expertFeedBackList: {
    textAlign: "Center",
    marginLeft: 10,
    marginRight: 10,
    marginTop: 5,
    cursor: "pointer"
  }
});
ExpertFeedbackScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  onSubmitExpertScore: PropTypes.func.isRequired,
  onSubmitExpertFeedback: PropTypes.func.isRequired,
  t: PropTypes.func,
  containerClass: PropTypes.string
};
export default withStyles(styles)(withi18n(ExpertFeedbackScreen, "ExpertFeedbackScreen"));